const getUniqueElementsArray = <T>(array: T[]) => Array.from(new Set(array));

export default getUniqueElementsArray;
